import $ from 'zepto'

import {
    resolve,
    renderJsonLd,
    renderToStaticMarkup,
    getValueByIdentifier,
    EXTERNAL_IDENTIFIERS
} from '@wix/advanced-seo-utils/renderer'

import {convertDynamicPageModel, convertSeoModel, convertTpaModel} from '@wix/advanced-seo-utils/converters'

import {withActions} from 'carmi-host-extensions'

// get this from aspectNames once we are there
export const name = 'SeoAspect'

export const defaultModel = {
    overrides: {},
    jsonLd: {},
    siteMetadataChangedRegisteredComps: {}
}

const setRunTimePageTitle = (windowObject, title) => {
    if (windowObject && title) {
        windowObject.document.title = title
        return title
    }
    return null
}

function getRunTimePageDescription(windowObject) {
    if (windowObject && windowObject.document) {
        return $('meta[name=description]', windowObject.document.head).attr('content')
    }
    return undefined
}

export const functionLibrary = {
    registerToSiteMetadataChange: withActions((aspectActions, compId, comp) => {
        aspectActions.setMetadataChangedRegisteredComp(compId, comp)
    }),
    unRegisterToSiteMetadataChange: withActions((aspectActions, compId) => {
        aspectActions.setMetadataChangedRegisteredComp(compId, undefined)
    }),
    getTags: (prioritizedData, context) => resolve(prioritizedData, context),
    getTagsMarkup: (tags, jsonLd) => renderToStaticMarkup(tags).concat(jsonLd ? jsonLd : []),
    updateJsonLd: withActions((aspectActions, pageId, jsonLd) => {
        if (jsonLd) {
            aspectActions.setJsonLd(pageId, jsonLd)
        }
    }),
    setRunTimePageTitle,
    setRunTimePageDescription: (windowObject, desc, shouldSet) => {
        if (shouldSet) {
            $('meta[name=description]', windowObject.document.head).remove()
            $(windowObject.document.head).append('<meta name="description"/>')
            $('meta[name=description]').attr('content', desc)
            return desc
        }
        return null
    },
    getJsonLdTagMarkup: jsonLd => jsonLd && renderJsonLd(jsonLd),
    getRunTimePageTitle: windowObject => windowObject && windowObject.document.title,
    getRunTimePageDescription,

    updatePageTitle: (title, windowObject) => setRunTimePageTitle(windowObject, title),

    getTitle: tags => getValueByIdentifier(tags, EXTERNAL_IDENTIFIERS.TITLE),
    getDescription: tags => getValueByIdentifier(tags, EXTERNAL_IDENTIFIERS.DESCRIPTION),

    convertSeoModel: blob => convertSeoModel(blob),
    convertDynamicPageModel: blob => convertDynamicPageModel(blob),
    convertTpaModel: blob => convertTpaModel(blob)
}
